'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../utils/client');

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
  return {
    fields: _extends({
      name: {
        label: 'Team name',
        placeholder: 'Enter your team name'
      }
    }, (0, _client.isJustGiving)() && {
      target: {
        type: 'number',
        label: 'Fundraising target',
        placeholder: '100',
        validators: [validators.required('Enter your team fundraising target')]
      },
      story: {
        type: 'textarea',
        label: 'Team story',
        validators: [validators.required('Please enter your team story')]
      }
    })
  };
};